import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=31ddd9ba&scoped=true"
import script from "./Stars.vue?vue&type=script&lang=js"
export * from "./Stars.vue?vue&type=script&lang=js"
import style0 from "./Stars.vue?vue&type=style&index=0&id=31ddd9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ddd9ba",
  null
  
)

export default component.exports